import React, { Ref } from 'react';
import { Form as BaseForm } from '@unform/web';
import { FormProps, FormHandles } from '@unform/core';
import { Stack, StackProps } from '@chakra-ui/react';

type IStackForm = Omit<StackProps, 'onSubmit'> & Omit<FormProps, 'ref'>;

interface IProps extends IStackForm {
  ref?: Ref<FormHandles>;
}

const Form: React.FC<IProps> = React.forwardRef(
  ({ children, spacing, ...rest }, ref) => {
    return (
      <BaseForm ref={ref} autoComplete="off" {...rest}>
        <Stack spacing={spacing}>{children}</Stack>
      </BaseForm>
    );
  },
);

export default Form;
